module.exports = __webpack_public_path__ + "static/media/algae2.a19cb31e.svg";